import { IconButton } from '@material-ui/core';
import React from 'react';
import { TaskStatusEnum } from '@redux/tasks/tasksTypes';
import { DropDownMenu } from 'components/DropDownMenu/DropDownMenu';
import { FREQUENCY_SELECT_OPTIONS } from 'components/FrequencySelectBlock/FrequencySelectBlock';
import { CircleIcon, DotsThreeIcon, ListChecksIcon, XSquareIcon } from 'components/Icons';
import { TaskMenuProps } from 'containers/Tasks/components/TasksTable/TasksTable.types';
import { Color } from 'utils/color';

export const TaskMenu: React.FC<TaskMenuProps> = ({ onSelectTask, onCancelTask, status, frequency }) => {
  return (
    <DropDownMenu
      customMenuElement={(onMenuClick) => (
        <IconButton onClick={onMenuClick} size="small">
          <DotsThreeIcon />
        </IconButton>
      )}
      menuItems={[
        {
          text: 'View details',
          onClick: onSelectTask,
          icon: () => <ListChecksIcon width={16} height={16} />
        },
        frequency !== "Doesn't Repeat" && {
          text: status === TaskStatusEnum.SCHEDULED ? 'Cancel this and all future tasks' : 'Cancel all future tasks',
          onClick: () => onCancelTask(false),
          icon: () => <CircleIcon width={16} height={16} color={Color.GRAY_950} />
        },
        {
          text: 'Cancel',
          onClick: () => onCancelTask(true),
          icon: () => <XSquareIcon width={16} height={16} />,
          disabled: status !== TaskStatusEnum.SCHEDULED
        }
      ]}
    />
  );
};
